import { createAction } from '@reduxjs/toolkit'

import * as types from './types'

export const setSideBarStatus = createAction(types.SET_SIDEBAR_STATUS)

export const setSocioExpanded = createAction(types.SET_SOCIO_EXPANDED)

export const setConfigExpanded = createAction(types.SET_CONFIG_EXPANDED)
